import { RangeType } from './range-type.model';
import { UpdateDeleteState } from './update-delete-state.model';

export interface ResultClassValue {
  ID: number;
  ChkMainCollectionsID: number;
  ChkResultClassID: number;
  Value: string | null;
  FromValue: number;
  ToValue: number;
  RangeType: RangeType;
  BackgroundColor: string;
  ForegroundColor: string;
  Score: number | null;
  Outcome: ChkOutcomeType;
  AttachmentRequired: boolean | null;
  RemarksRequired: boolean | null;
  UpdateDeleteState: UpdateDeleteState;
  EditMode: boolean;
}

export enum ChkOutcomeType {
  Unknown = 0,
  Positive = 1,
  Negative = 2,
}